import React,{useEffect, useState} from 'react'
import Layout from '../../../components/Layout/Layout'
import axios from "axios";
import { useAuth } from '../../../context/auth';
import {useNavigate, useParams} from 'react-router-dom'
import toast from 'react-hot-toast';
import {Table,Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { FaSave  } from "react-icons/fa";
import { SERVER_API } from '../../../fileWithConstants';
import EditAddDeleteTableRows from './EditAddDeleteTableRows';
const EditpoElements = () => {
    const params = useParams();
    const po_id = params.po_id;
    const[auth, setAuth] =useAuth();
    const[userId, setUserId]=useState(auth.user.id);
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [supplier, setSupplier] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [singleSelections, setSingleSelections] = useState([]);
    const [poDate, setPoDate] = useState(new Date());
    const [delDate, setDelDate] = useState(new Date());
    const [po_number, setPo_number] = useState('');
    const [rowlist, setRowlist] = useState([]);
    const [supplierId, setSupplierId] = useState("");
    const[fabrics, setFabrics] = useState([]);
    const[pomainData, setPomainData] = useState([]);
    const[instructedBY, setInstructedBY] = useState('');
    const [validated, setValidated] = useState(false);
    const getAllSupplier = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
          if(data?.success && data?.suppliers?.length>0){
            setSupplier(data?.suppliers)
          }
        } catch (error) {
          console.log(error)
        }
    }

    const getPodata = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-element-po/${po_id}`);
          if(data?.success && data?.podata?.length>0){
            const p_data = data?.podata[0];
            setPomainData(p_data)
            console.log(p_data)
            setSingleSelections([{v_id:p_data.supplier,code:p_data.code}])
            if(supplier.length>0){
                const sel_supp = supplier.filter(sup=>sup.v_id==supplierId);
                setSingleSelections(sel_supp)
            }
            setPo_number(`PO-${p_data.po_num}`);
            setInstructedBY(p_data.instructed_by)
            setPoDate(new Date(p_data.po_date));
            setDelDate(new Date(p_data.del_date));


            let subtotal=p_data.sub_total;
            let gst=p_data.gst;
            let totalAmount=p_data.total;
            let deliveryAdd=p_data.del_address;
            let notes=p_data.notes;
            //console.log(subtotal,gst,totalAmount,deliveryAdd,notes)
            handlePodata({subtotal,gst,totalAmount,deliveryAdd,notes});
          }
        } catch (error) {
          console.log(error)
        }
    }

    const getPoSingledata = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-single-element-po-data/${po_id}`);
          
          if(data?.success && data?.posingledata?.length>0){
            const poDetailDataArr = data?.posingledata.map(item=>{
              return {
                qty:item.qty,
                price:item.price,
                unit:item.unit,
                discount:item.discount,
                amount:item.amount,
                gst:item.gst,
                name:item.fabric,
              };
            })
            setRowlist(poDetailDataArr)
          }
        } catch (error) {
          console.log(error)
        }
    }

    const getSupplierAllFabrics = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-supplier-elements/${supplierId}`);
          if(data?.success && data?.fabrics?.length>0){
            setFabrics(data?.fabrics)
          }
        } catch (error) {
          console.log(error)
        }
    }

    useEffect(()=>{ 
        getAllSupplier();
        getPodata(); 
        getPoSingledata();
        //console.log(supplier.slice(0, 1))
    },[])

   
    useEffect(()=>{
        if(supplierId>0){
            getSupplierAllFabrics();
        }
    },[supplierId])

    const handleSubmit = async(e)=>{
        e.preventDefault();
        const form = e.currentTarget;
        if(form.checkValidity()===false){
            e.stopPropagation();
        }
        setValidated(true);
    if(form.checkValidity()===true && !submitting && supplierId!=='') {
        try {
            const formData = new FormData();
            formData.append('po_id',po_id);
            formData.append("supplierId", supplierId);    
            formData.append("date", poDate);    
            formData.append("delDate", delDate);    
            formData.append("po_number", po_number);
            formData.append("user_id",userId);
            formData.append("instructed_by",instructedBY);

            formData.append("pomainData", JSON.stringify(pomainData));
            formData.append("row_data", JSON.stringify(rowlist));
            const {data} = await axios.put(`${SERVER_API}/api/v1/element/update-po-element-data/${po_id}`,formData,{
                headers:{'Content-Type': 'application/json'}
              });
              //console.log(data)
            if(data?.success){
                toast.success(data.message);
                navigate('/dashboard/elements-po-listing')
            }

            } catch (error) {
                console.log(error)
            } finally {
                setSubmitting(false);
            }
        }
    }

    useEffect(()=>{
        if(singleSelections.length>0){
            //console.log(singleSelections);
            if(supplierId!==singleSelections?.[0]['v_id']){
                //setRowlist('');
            }
            setSupplierId(singleSelections?.[0]['v_id']);
        }

        pomainData['instructed_by']=instructedBY;
        pomainData['po_date']=poDate;
        pomainData['del_date']=delDate;
    });


    const handleRowdata = values => {
        setRowlist(values);
     }

     const handlePodata = (podata) =>{
        pomainData['del_id']=podata.delId;
        pomainData['del_address']=podata.deliveryAdd;
        pomainData['notes']=podata.notes;
        pomainData['sub_total']=podata.subtotal;
        pomainData['total']=podata.totalAmount;
        pomainData['gst']=podata.gst;
     }

     const cancelHandle = ()=>{
        navigate('/dashboard/elements-po-listing');
      }

  return (
    <Layout title={`Edit Purchase Order(Kali/Dupatta) (${po_number})`}>
        <div className='container-fluid col-md-6 form-container--'>
            <Form noValidate validated={validated} onSubmit={handleSubmit} className='form-section'>
                <h4 className='title'>Edit Purchase Order(Kali/Dupatta)</h4>
                    <div className='form-box'>
                    <div className="row">
                        <div className="mb-3 col-md-3">
                        <label>Supplier*</label>
                        <Typeahead
                            inputProps={{ required: true }}
                            name="supplier_id"
                            id="basic-typeahead-single"
                            labelKey="code"
                            onChange={setSingleSelections}
                            options={supplier}
                            placeholder="Choose a supplier"
                            selected={singleSelections}
                        />
                        </div>

                        <div className="mb-3 col-md-2">
                            <label>PO Date*</label>
                            <DatePicker
                            required
                            name='date'
                            className='form-control'
                            dateFormat="dd-MM-yyyy"
                            selected={poDate}
                            onChange={(date) => setPoDate(date)}
                            selectsStart
                            startDate={poDate}
                            endDate={delDate}
                            />
                        </div>
                        <div className="mb-3 col-md-2">
                            <label>Delivery Date*</label>
                            <DatePicker
                            required
                            name='del_dt'
                            className='form-control'
                            dateFormat="dd-MM-yyyy"
                            selected={delDate}
                            onChange={(date) => setDelDate(date)}
                            selectsEnd
                            startDate={poDate}
                            endDate={delDate}
                            minDate={poDate}
                            />
                        </div>

                        <div className="mb-3 col-md-2">
                            <label>Po Number*</label>
                            <Form.Control required type='text' name="po_number" className='form-control' value={po_number} readOnly/>
                        </div>
                        
                        <div className="mb-3 col-md-2">
                            <label>Instructed By*</label>
                            <select required className='form-control' name="instructed_by" value={instructedBY} onChange={(e)=>(setInstructedBY(e.target.value) )}>
                                <option value={""}>--Select--</option>
                                <option value={1}>Ketan Sethi</option>
                                <option value={2}>Maansi Sethi</option>
                            </select>
                        </div>

                        <EditAddDeleteTableRows fabrics={fabrics} handleRowdata={handleRowdata} handlePodata={handlePodata}/>

                        <div className='row'>
                        <div className='col-6'> <button type="submit" className="btn btn-dark form-control"> Update PO Data</button></div>
                        <div className='col-2'> <button type="button" onClick={cancelHandle} className="btn btn-dark form-control">Cancel</button></div>
                        </div>

                    </div>
                </div>      
            </Form>
        </div>
    </Layout>
  )
}

export default EditpoElements
